module.exports = __webpack_public_path__ + "static/Gallery-7-c162027750f947b720d8473084ccb497.jpg";